import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIKitActionListModule } from 'app/shared/ui-kit/action-list/action-list.module';
import { UIKitButtonModule } from './button';
import { UIKitDatePicker } from './date-picker/date-picker.component';
import { UIKitDateTimePickerModule } from './date-time-picker';
import { UIKitFormFieldModule } from './form-field/form-field.module';
import { UIKitIconModule } from './icon';
import { UIKitInputModule } from './input/input.module';
import { UIKitRadioModule } from './radio/radio.module';
import { UIKitSelectModule } from './select/select.module';
import { UIKitSquareButtonModule } from './square-button/square-button.module';
import { UIKitStepper } from './stepper/stepper.component';
import { UIKitStepperModule } from './stepper/stepper.module';
import { UIKitTooltipModule } from './tooltip/tooltip.module';
@NgModule({
  imports: [
    CommonModule,
    UIKitFormFieldModule,
    UIKitButtonModule,
    UIKitIconModule,
    UIKitInputModule,
    UIKitDatePicker,
    UIKitDateTimePickerModule,
    UIKitStepperModule,
    UIKitTooltipModule,
    UIKitRadioModule,
    UIKitSelectModule,
    UIKitSquareButtonModule,
    UIKitActionListModule,
    UIKitStepper,
  ],
  exports: [
    UIKitFormFieldModule,
    UIKitButtonModule,
    UIKitIconModule,
    UIKitInputModule,
    UIKitDatePicker,
    UIKitDateTimePickerModule,
    UIKitStepperModule,
    UIKitTooltipModule,
    UIKitRadioModule,
    UIKitSelectModule,
    UIKitSquareButtonModule,
    UIKitActionListModule,
    UIKitStepper,
  ],
})
export class UIKitModule {}
